import InputField from "@metacrm/metacrm-material-ui/dist/InputField";
import Popup from "@metacrm/metacrm-material-ui/dist/Popup";
import { Box } from "@mui/material";
import axios from "axios";
import { apiUrl } from "features/configure";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import React, { useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useOutletContext } from "react-router";

export default function TrainingEditModal({
  editInfo,
  onClose,
  refresh,
  setCanUpdateResponse,
}) {
  const [input, setInput] = useState(editInfo.improvedResponse);
  const [isLoading, setIsLoading] = useState(false);
  const initInput = useRef(editInfo.improvedResponse);
  const dispatchSnackbar = useDispatchSnackbar();
  const [entityName] = useOutletContext();

  const handleSave = async () => {
    try {
      setIsLoading(true);
      await axios.post(`${apiUrl}/api/trainingArea/${entityName}/messages`, {
        messageId: editInfo._id,
        improvedResponse: input,
      });
      setCanUpdateResponse(true);
      onClose();
      if (refresh) refresh();
    } catch (err) {
      console.log(err);
      dispatchSnackbar({ err });
    } finally {
      setIsLoading(false);
    }
  }
  const { formatMessage } = useIntl();

  const disabled = input?.trim() === "" || input === initInput.current;
  return (
    <Popup
      open={true}
      onClose={onClose}
      title={
        <Box fontSize={20}>
          {formatMessage({ id: "trainingArea.popup.improveResponse.title" })}
        </Box>
      }
      size="sm"
      showFooter={true}
      onCancel={onClose}
      onConfirm={handleSave}
      confirmText={formatMessage({ id: "global.btn.save" })}
      cancelText="Do It Later"
      confirmProps={{ disabled, isLoading }}
    >
      <Box fontSize={16} fontWeight={700} color="#555" mb="8px">
        {formatMessage({ id: "trainingArea.popup.improveResponse.desc" })}
      </Box>
      <Box
        fontSize={14}
        color="#555"
        mb="24px"
        lineHeight={"20px"}
        maxHeight="200px"
        overflow="auto"
      >
        {editInfo?.originalResponse}
      </Box>
      <InputField
        multiline
        title={formatMessage({ id: "trainingArea.column.improvedResponse" })}
        placeholder="Provide a clearer response for AI to learn from."
        value={input}
        rows={5}
        onChange={(e) => setInput(e.target.value)}
      />
    </Popup>
  );
}
